import { UserIsAuthenticated, UserHasValidPassword, UserHasScope, UserDoesNotHaveRole } from 'containers/authContainers'
import { injectReducers } from 'store/reducers'
import { loadingActions } from 'store/loader'
import { isSameUser, checkUserHasScope } from 'utils/userUtils'
import { USER_ROLES_WITH_RESTRICTED_ACCESS, USER_ROLE_ID_MAP } from 'utils/constants'
import ParticipantsPage from './containers/ParticipantsContainer'
import sitesReducer, { fetchSites } from '../../../Sites/routes/SitesPage/modules/Sites'
import userReducer, { actions as userActions } from '../../../Users/routes/CreateUser/modules/CreateUser'
import consentsReducer, { consentActions } from '../../../Consents/routes/ConsentsDashboard/modules/Consents'
import { actions } from './modules/Participants'
import { actions as createPtpActions } from '../CreateParticipant/modules/CreateParticipant'
import { fetchStudies } from '../../../../../../StudiesPage/modules/Studies'
import { actions as visitScheduleActions } from '../../../VisitSchedules/routes/VisitSchedulesPage/modules/VisitSchedules'

const { fetchUserSites } = userActions

export default store => ({
  exact: true,
  getComponent(nextState, cb) {
    require.ensure(
      [],
      () => {
        injectReducers(store, {
          sites: sitesReducer,
          userReducer,
          consents: consentsReducer,
        })
        const { params } = nextState
        const { studyID } = params
        const { studies, study, user } = store.getState()
        const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
        const isEnroller = user?.permissions?.[studyID]?.role_id === USER_ROLE_ID_MAP.enroller
        const canFetchVisitSchedules = checkUserHasScope({ user, studyId: studyID, scope: ['wpv', 'rpv'] })
        const shouldFetchCaregivers = study?.currentStudy?.config?.caregivers?.version === 2 && hasStudyPromotion

        store.dispatch(fetchUserSites({ studyId: studyID, userId: user.id }))
        store.dispatch(fetchSites(studyID, true, false, false))
        if (isSameUser(user.id) ?? true) {
          store.dispatch(loadingActions.startLoader(true))
          if (studies.length === 0) {
            store.dispatch(fetchStudies(false))
          }
          if (!!study?.currentStudy?.config?.visit_support && !isEnroller && canFetchVisitSchedules) {
            store.dispatch(visitScheduleActions.fetchVisitSchedules(studyID))
            store.dispatch(createPtpActions.fetchVisitTemplates(studyID))
          }
          const promises = [
            store.dispatch(actions.fetchPtpsAndCohorts(studyID)),
            store.dispatch(consentActions.fetchBlockedConsents(studyID)),
          ];

          if (shouldFetchCaregivers) {
            promises.push(store.dispatch(actions.fetchCaregivers(studyID)));
          }

          Promise.all(promises)
            .then(() => {
              store.dispatch(loadingActions.stopLoader(true))
            })
            .catch(() => {
              store.dispatch(loadingActions.stopLoader(true))
            })
        }
        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(
              UserHasScope(
                ['rp', 'rp-no-pii'],
                UserDoesNotHaveRole(USER_ROLES_WITH_RESTRICTED_ACCESS, ParticipantsPage),
                false,
                studyID,
              ),
            ),
          ),
        )
      },
      'participants',
    )
  },
})